module.exports = __webpack_public_path__ + "img/banner_industry.0af457cf.jpg";